import React, { useState, useEffect } from 'react';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
import { Link, Outlet, useLocation } from 'react-router-dom';
import WhatsAppFloat from '../pages/WhatsApp';
import logo1 from '../imgs/logo1.png';
const Layout = () => {
  const [scrolled, setScrolled] = useState(false);
  const [showBackToTop, setShowBackToTop] = useState(false);
  const location = useLocation();
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
      setShowBackToTop(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        body {
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        }

        /* Navbar Styles */
        .custom-navbar {
          background-color: #fff;
          box-shadow: 0 2px 20px rgba(0,0,0,0.1);
          transition: all 0.3s ease;
          padding: 0.5rem 0;
        }

        .custom-navbar.scrolled {
          background-color:#fff;
          box-shadow: 0 4px 30px rgba(0,0,0,0.2);
          padding: 0.3rem 0;
        }

        .navbar-brand {
          display: flex;
          align-items: center;
          font-weight: 700;
          font-size: 1.5rem;
          color: #fff !important;
          transition: transform 0.3s ease;
        }

        .navbar-brand:hover {
          transform: scale(1.05);
        }

        .logo-image {
          width: 150px;
          height: 70px;
          margin-right: 12px;
          overflow: hidden;
        }

        .logo-image:hover {
          transform: scale(1.1);
        }

        .scrolled .logo-image {
          width: 100px;
          height: 40px;
        }

        .nav-link {
          color: rgba(7, 6, 6, 0.9) !important;
          font-weight: 500;
          padding: 0.5rem 1rem !important;
          margin: 0 0.2rem;
          position: relative;
          transition: all 0.3s ease;
        }

        .nav-link::before {
          content: '';
          position: absolute;
          bottom: 0;
          left: 50%;
          width: 0;
          height: 3px;
          background: linear-gradient(90deg, #667eea, #764ba2);
          transform: translateX(-50%);
          transition: width 0.3s ease;
          border-radius: 3px;
        }

        .nav-link:hover::before,
        .nav-link.active::before {
          width: 80%;
        }

        .nav-link:hover {
          color: #000 !important;
          transform: translateY(-2px);
        }

        .dropdown-menu {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border: none;
          box-shadow: 0 10px 40px rgba(0,0,0,0.2);
          border-radius: 12px;
          padding: 0.5rem 0;
          margin-top: 0.5rem;
        }

        .dropdown-item {
          color: rgba(255,255,255,0.9);
          padding: 0.7rem 1.5rem;
          transition: all 0.3s ease;
          font-weight: 500;
        }

        .dropdown-item:hover {
          background: rgba(255,255,255,0.2);
          color: #171616ff;
          transform: translateX(5px);
          padding-left: 1.8rem;
        }

        .dropdown-toggle::after {
          margin-left: 0.5rem;
          transition: transform 0.3s ease;
        }

        .dropdown.show .dropdown-toggle::after {
          transform: rotate(180deg);
        }

        .navbar-toggler {
          border-color: rgba(35, 147, 223, 1);
          padding: 0.5rem;
        }

        .navbar-toggler-icon {
          background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(7, 21, 88, 0.9)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
        }

        /* Main Content */
        main {
          min-height: calc(100vh - 400px);
          padding-top: 2rem;
        }

        /* Footer Styles */
        .custom-footer {
          background: linear-gradient(135deg, #0f2027 0%, #203a43 50%, #2c5364 100%);
          color: #fff;
          padding: 3rem 0 1rem;
          margin-top: 4rem;
          position: relative;
          overflow: hidden;
        }

        .custom-footer::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(90deg, #667eea, #764ba2, #f093fb);
        }

        .footer-section {
          margin-bottom: 2rem;
        }

        .footer-title {
          font-size: 1.3rem;
          font-weight: 700;
          margin-bottom: 1rem;
          color: #fff;
          position: relative;
          padding-bottom: 0.5rem;
        }

        .footer-title::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 50px;
          height: 3px;
          background: linear-gradient(90deg, #667eea, #764ba2);
          border-radius: 3px;
        }

        .footer-text {
          color: rgba(255,255,255,0.8);
          line-height: 1.8;
          font-size: 0.95rem;
        }

        .footer-links {
          list-style: none;
          padding: 0;
        }

        .footer-links li {
          margin-bottom: 0.7rem;
        }

        .footer-links a {
          color: rgba(255,255,255,0.8);
          text-decoration: none;
          transition: all 0.3s ease;
          display: inline-block;
          position: relative;
          padding-left: 20px;
        }

        .footer-links a::before {
          content: '▸';
          position: absolute;
          left: 0;
          color: #667eea;
          transition: left 0.3s ease;
        }

        .footer-links a:hover {
          color: #fff;
          padding-left: 25px;
        }

        .footer-links a:hover::before {
          left: 5px;
        }

        .social-links {
          display: flex;
          gap: 1rem;
          margin-top: 1rem;
        }

        .social-icon {
          width: 45px;
          height: 45px;
          background: rgba(255,255,255,0.1);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          text-decoration: none;
          font-size: 1.2rem;
          transition: all 0.3s ease;
          backdrop-filter: blur(10px);
        }

        .social-icon:hover {
          background: linear-gradient(135deg, #667eea, #764ba2);
          transform: translateY(-5px) rotate(360deg);
          box-shadow: 0 10px 25px rgba(102, 126, 234, 0.4);
        }

        .footer-bottom {
          border-top: 1px solid rgba(255,255,255,0.1);
          padding-top: 1.5rem;
          margin-top: 2rem;
          text-align: center;
          color: rgba(255,255,255,0.6);
          font-size: 0.9rem;
        }

        .contact-info {
          display: flex;
          flex-direction: column;
          gap: 0.8rem;
        }

        .contact-item {
          display: flex;
          align-items: center;
          color: rgba(255,255,255,0.8);
          gap: 0.7rem;
        }

        .contact-icon {
          width: 35px;
          height: 35px;
          background: linear-gradient(135deg, #667eea, #764ba2);
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1rem;
          flex-shrink: 0;
        }

        /* Back to Top Button */
        .back-to-top {
          position: fixed;
          bottom: 30px;
          right: 30px;
          width: 50px;
          height: 50px;
          background: linear-gradient(135deg, #667eea, #764ba2);
          border: none;
          border-radius: 50%;
          color: #fff;
          font-size: 1.5rem;
          cursor: pointer;
          box-shadow: 0 5px 25px rgba(102, 126, 234, 0.4);
          transition: all 0.3s ease;
          z-index: 1000;
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0;
          visibility: hidden;
          transform: scale(0);
        }

        .back-to-top.show {
          opacity: 1;
          visibility: visible;
          transform: scale(1);
        }

        .back-to-top:hover {
          transform: scale(1.1) translateY(-5px);
          box-shadow: 0 8px 30px rgba(102, 126, 234, 0.6);
        }

        /* Responsive */
        @media (max-width: 992px) {
          .navbar-collapse {
            background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
            padding: 1rem;
            border-radius: 12px;
            margin-top: 1rem;
            box-shadow: 0 10px 40px rgba(0,0,0,0.2);
          }

          .nav-link::before {
            display: none;
          }

          .social-links {
            justify-content: center;
          }
        }
      `}</style>

      <Navbar expand="lg" sticky="top" className={`custom-navbar ${scrolled ? 'scrolled' : ''}`} expanded={expanded} onToggle={setExpanded}>
        <Container>
          <Navbar.Brand as={Link} to="/">
            <div className="logo-image">
              <img 
                src={logo1} 
                alt="Nakshatra Infra Logo" 
                style={{ width: '100%', height: '100%', backgroundColor: '#fff' }}
              />
            </div>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link as={Link} to="/" onClick={() => setExpanded(false)}>Home</Nav.Link>
              <Nav.Link as={Link} to="/about" onClick={() => setExpanded(false)}>About Us</Nav.Link> 
              <NavDropdown title="Projects" id="projects-dropdown">
                <NavDropdown.Item as={Link} to="/projects/UpcomingProjects" onClick={() => setExpanded(false)}>Upcoming Projects</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/projects/CompletedProjects" onClick={() => setExpanded(false)}>Completed Projects</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/projects/open-plots" onClick={() => setExpanded(false)}>Open Plots</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/projects/residential-ventures" onClick={() => setExpanded(false)}>Residential Ventures</NavDropdown.Item>
              </NavDropdown>
              <NavDropdown title="Services" id="services-dropdown">
                <NavDropdown.Item as={Link} to="/services/plot-sales" onClick={() => setExpanded(false)}>Plot Sales</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/services/venture-development" onClick={() => setExpanded(false)}>Venture Development</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/services/end-to-end-solutions" onClick={() => setExpanded(false)}>End-to-End Solutions</NavDropdown.Item>
              </NavDropdown>
              <Nav.Link as={Link} to="/gallery" onClick={() => setExpanded(false)}>Gallery</Nav.Link>
              <Nav.Link as={Link} to="/contact" onClick={() => setExpanded(false)}>Contact Us</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <main>
        <Outlet />
      </main>

      <footer className="custom-footer">
        <Container>
          <div className="row">
            <div className="col-lg-4 col-md-6 footer-section">
              <h5 className="footer-title">Nakshatra Infra Projects</h5>
              <p className="footer-text">
                HMDA & RERA Approved Projects – Your Trusted Real Estate Partner in Hyderabad. 
                Building dreams with quality, transparency, and excellence.
              </p>
              <div className="social-links">
                <a href="#" className="social-icon" aria-label="Facebook">f</a>
                <a href="#" className="social-icon" aria-label="Twitter">𝕏</a>
                <a href="#" className="social-icon" aria-label="Instagram">📷</a>
                <a href="#" className="social-icon" aria-label="LinkedIn">in</a>
              </div>
            </div>

            <div className="col-lg-2 col-md-6 footer-section">
              <h5 className="footer-title">Quick Links</h5>
              <ul className="footer-links">
                <li><a href="#about">About Us</a></li>
                <li><a href="#projects">Projects</a></li>
                <li><a href="#services">Services</a></li>
                <li><a href="#gallery">Gallery</a></li>
                <li><a href="#contact">Contact</a></li>
              </ul>
            </div>

            <div className="col-lg-3 col-md-6 footer-section">
              <h5 className="footer-title">Our Services</h5>
              <ul className="footer-links">
                <li><a href="#plots">Open Plots</a></li>
                <li><a href="#residential">Residential Projects</a></li>
                <li><a href="#solutions">Real Estate Solutions</a></li>
              </ul>
            </div>

            <div className="col-lg-3 col-md-6 footer-section">
              <h5 className="footer-title">Contact Info</h5>
              <div className="contact-info">
                <div className="contact-item">
                  <div className="contact-icon">📍</div>
                  <span>Sri Sai Govardhan Kunj, F 401, Sanjeeva Reddy Nagar, Hyderabad, Telangana 500038</span>
                </div>
                <div className="contact-item">
                  <div className="contact-icon">📞</div>
                  <a
  href="tel:+919618889887"
  style={{ fontWeight: 600, textDecoration: "none", color: "inherit" }}
>
  +919618889887
</a>
                </div>
                <div className="contact-item">
                  <div className="contact-icon">✉</div>
                  <a
  href="mailto:nakshatrainfraprojects160@gmail.com"
  style={{
    fontWeight: 600,
    wordBreak: "break-word",
    textDecoration: "none",
    color: "inherit",
  }}
>
  nakshatrainfraprojects160@gmail.com
</a>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <p>&copy; 2024 Nakshatra Infra Projects. All Rights Reserved. | Privacy Policy | Terms & Conditions</p>
          </div>
        </Container>
      </footer>

      <button 
        className={`back-to-top ${showBackToTop ? 'show' : ''}`}
        onClick={scrollToTop}
        aria-label="Back to top"
      >
        ↑
      </button>

      <WhatsAppFloat />
    </>
  );
};

export default Layout;